import React from 'react'
import { EditIcon } from '@chakra-ui/icons'
import { useNavigate } from 'react-router-dom'
import { Text, Button, Table, Thead, Tbody, Th, Tr, Td } from '@chakra-ui/react'

import { Card, Page, PageHeader } from 'components'

import { useDimensionListQuery } from '../hooks'

export const DimensionListPage = () => {
  const navigate = useNavigate()
  const { data, error } = useDimensionListQuery()

  if (error) {
    return navigate('/login')
  }

  return (
    <Page>
      <PageHeader heading='Gerir Dimensōes' onBack={() => navigate('..')}>
        <Button
          variant='outline'
          colorScheme='yellow'
          leftIcon={<EditIcon />}
          onClick={() => navigate('./alterar-ponderacoes')}>
          Alterar Ponderaçōes
        </Button>
      </PageHeader>

      <Card p={3}>
        <Table>
          <Thead>
            <Tr>
              <Th>
                <Text>Nome</Text>
              </Th>
              <Th>
                <Text id='weight_column'>Ponderação</Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.map(({ name, weight }, index) => (
              <Tr key={index}>
                <Th id={`weight_cell_${index}`}>
                  <Text>{name}</Text>
                </Th>
                <Td aria-labelledby={`weight_column weight_cell_${index}`}>
                  <Text>{weight}</Text>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Card>
    </Page>
  )
}

export default DimensionListPage
